export default "assets/images/6345ee67d554fbfbf484ba4035ad19d9.jpg";